(async () => {
    showPreloader('#filter-shape');
    // showPreloader('#filter-price');
    showPreloader('#filter-weight');
    showPreloader('#filter-color');
    showPreloader('#filter-cutGrade');
    showPreloader('#filter-clarity');
    showPreloader('#filter-lab');

    // const priceRange = await getPriceRange({ vendor: ['Skylab', 'EcoLight'] });
    const weightRange = await getWeightRange({ vendor: ['Skylab', 'EcoLight'] });
    const filters = await getFilters({ vendor: ['Skylab', 'EcoLight'] });
    const shapes = await getShapes();

    await loadProducts(productQuery);

    hideAllPreloaders();

    var filterShapeContainer = $('#filter-shape-container');
    shapes.forEach(filter => {
        var filterBox = $('<div>');
        var img = $('<img>');
        img.attr('src', filter.image);

        filterBox.attr('data-filter_value', filter.name);
        filterBox.addClass('margin-0-05em').addClass('margin-0-05em filter-list-item flex column center');
        filterBox.append(img);
        filterBox.append(filter.name.toUpperCase());
        filterShapeContainer.append(filterBox);
    });
    if (window.shapeValues) {
        filterShapeContainer.find('.filter-list-item').each(function(index, shape_filter_item) {
            let $shape_filter_item = $(shape_filter_item);
            if (window.shapeValues.some(el => el.toUpperCase() === $shape_filter_item.data('filter_value').toUpperCase())) {
                $shape_filter_item.addClass('filter-enable');
            }
        });
    }

    var filterColorContainer = $('#filter-color-container');
    filters.color.forEach(filter => {
        var filterBox = $('<div>');
        filterBox.attr('data-filter_value', filter);
        filterBox.addClass('margin-0-05em').addClass('filter-list-item');
        filterBox.text(filter);
        filterColorContainer.append(filterBox);
    });

    var filterClarityContainer = $('#filter-clarity-container');
    filters.clarity.forEach(filter => {
        var filterBox = $('<div>');
        filterBox.attr('data-filter_value', filter);
        filterBox.addClass('margin-0-05em').addClass('filter-list-item');
        filterBox.text(filter);
        filterClarityContainer.append(filterBox);
    });

    var filterLabContainer = $('#filter-lab-container');
    filters.lab.forEach(filter => {
        var filterBox = $('<div>');
        filterBox.attr('data-filter_value', filter);
        filterBox.addClass('margin-0-05em').addClass('filter-list-item');
        filterBox.text(filter);
        filterLabContainer.append(filterBox);
    });

    var filterCutGradeContainer = $('#filter-cutGrade-container');
    filters.cut_grade.forEach(filter => {
        var filterBox = $('<div>');
        filterBox.attr('data-filter_value', filter);
        filterBox.addClass('margin-0-05em').addClass('filter-list-item');
        filterBox.text(cutListObject[filter]);
        filterCutGradeContainer.append(filterBox);
    });

    // Object.entries(priceRange).forEach(([key, value]) => {;
    //     var input = $('#filter-price #' + key + '-value');
    //     input.val(value);
    //     input.attr(key, value);
    // });

    // console.log(priceRange);
    
    // $("#price-range").slider({
    //     range: true,
    //     min: priceRange.minPrice,
    //     max: priceRange.maxPrice,
    //     values: [priceRange.minPrice, priceRange.maxPrice],
    //     step: 0.1,
    //     slide: function(event, ui) {
    //         $("#price-amount").val("$" + ui.values[0] + " - $" + ui.values[1]);
    //         $('#filter-price #min-value').val(ui.values[0]);
    //         $('#filter-price #max-value').val(ui.values[1]);
    //     },
    //     stop: async function(event, ui) {
    //         page = 1;
    //         productQuery.page = page;
    //         productQuery.filter.price_from = ui.values[0];
    //         productQuery.filter.price_to = ui.values[1];

    //         await loadProducts(productQuery, true);
    //         unscroll();
    //     }
    // });
    // $("#price-amount").val("$" + $("#price-range").slider("values", 0) + " - $" + $("#price-range").slider("values", 1));

    Object.entries(weightRange).forEach(([key, value]) => {
        var input = $('#filter-weight #' + key + '-value');
        input.val(value);
        input.attr(key, value);
    });
    
    $("#weight-range").slider({
        range: true,
        min: weightRange.minWeight,
        max: weightRange.maxWeight,
        values: [weightRange.minWeight, weightRange.maxWeight],
        step: 0.001,
        slide: function(event, ui) {
            $("#weight-amount").val(ui.values[0] + " - " + ui.values[1]);
            $('#filter-weight #min-value').val(ui.values[0]);
            $('#filter-weight #max-value').val(ui.values[1]);
        },
        stop: async function(event, ui) {
            page = 1;
            productQuery.page = page;
            productQuery.filter.weight_from = ui.values[0];
            productQuery.filter.weight_to = ui.values[1];

            await loadProducts(productQuery, true);
            unscroll();
        }
    });
    $("#weight-amount").val($("#weight-range").slider("values", 0).toFixed(2) + " - " + $("#weight-range").slider("values", 1).toFixed(2));
    // end weight range slider

    shapeBlocks = $('#filter-shape-container > *');
    shapeSortableBlocks = [];
    shapeNotSortableBlocks = [];
    $(shapeBlocks).each(function(index, value) {
        var i = shapeList.indexOf($(value).text().trim().toLowerCase());
        if (i != -1) {
            shapeSortableBlocks[i] = value;
        } else {
            shapeNotSortableBlocks.push(value);
        }
    });
    $('#filter-shape-container').html(shapeSortableBlocks);
    $('#filter-shape-container').append(shapeNotSortableBlocks);
    $('#filter-shape-container').show();
    // end sort shapes

    $(window).on('scroll', async function() {
        if (loading) return;

        var target = $('.filter-table'); // Блок, за кінцем якого стежимо
        if (!target.length) return; // Перевірка, чи існує елемент

        var windowHeight = $(window).height();
        var scrollTop = $(window).scrollTop();
        
        // Отримуємо позицію блоку відносно верху документа + його повну висоту
        var blockBottom = target.offset().top + target.outerHeight();

        // Якщо низ блоку з'явився в зоні видимості (з запасом 400px)
        if (scrollTop + windowHeight >= blockBottom - 400) {
            loading = true;
            page++;
            productQuery.page = page;

            try {
                await loadProducts(productQuery);
            } catch (e) {
            } finally {
                loading = false;
            }
        }
    });

    filterShapeContainer.find('.filter-list-item').on('click', async function(e) {
        var filterItem = $(e.currentTarget);
        var filterValue = filterItem.attr('data-filter_value');

        if (!productQuery.filter) {
            productQuery.filter = {};
        }

        if (!Array.isArray(productQuery.filter.shape)) {
            productQuery.filter.shape = [];
        }

        var isEnable = filterItem.hasClass('filter-enable');

        if (isEnable) {
            filterItem.removeClass('filter-enable');
            productQuery.filter.shape = productQuery.filter.shape.filter(v => v.toUpperCase() !== filterValue.toUpperCase());
        } else {
            filterItem.addClass('filter-enable');
            productQuery.filter.shape.push(filterValue.toUpperCase());
        }

        if (productQuery.filter.shape.length === 0) {
            delete productQuery.filter.shape;
        }

        page = 1;
        productQuery.page = page;

        console.log('Shape filter:', productQuery.filter.shape);

        await loadProducts(productQuery, true);
        unscroll();
    });


    filterColorContainer.find('.filter-list-item').on('click', async function(e) {
        var filterItem = $(e.currentTarget);
        var filterValue = filterItem.attr('data-filter_value');

        if (!productQuery.filter) {
            productQuery.filter = {};
        }

        if (!Array.isArray(productQuery.filter.color)) {
            productQuery.filter.color = [];
        }

        var isEnable = filterItem.hasClass('filter-enable');

        if (isEnable) {
            productQuery.filter.color = productQuery.filter.color.filter(v => v !== filterValue);
            filterItem.removeClass('filter-enable');
        } else {
            productQuery.filter.color.push(filterValue);
            filterItem.addClass('filter-enable');
        }

        if (productQuery.filter.color.length === 0) {
            delete productQuery.filter.color;
        }

        page = 1;
        productQuery.page = page;

        console.log('color filter:', productQuery.filter.color);
        await loadProducts(productQuery, true);

        unscroll();
    });

    filterCutGradeContainer.find('.filter-list-item').on('click', async function(e) {
        var filterItem = $(e.currentTarget);
        var filterValue = filterItem.attr('data-filter_value');

        if (!productQuery.filter) {
            productQuery.filter = {};
        }

        if (!Array.isArray(productQuery.filter.cut_grade)) {
            productQuery.filter.cut_grade = [];
        }

        var isEnable = filterItem.hasClass('filter-enable');

        if (isEnable) {
            productQuery.filter.cut_grade = productQuery.filter.cut_grade.filter(v => v !== filterValue);
            filterItem.removeClass('filter-enable');
        } else {
            productQuery.filter.cut_grade.push(filterValue);
            filterItem.addClass('filter-enable');
        }

        if (productQuery.filter.cut_grade.length === 0) {
            delete productQuery.filter.cut_grade;
        }

        page = 1;
        productQuery.page = page;

        console.log('cut_grade filter:', productQuery.filter.cut_grade);
        await loadProducts(productQuery, true);

        unscroll();
    });

    filterLabContainer.find('.filter-list-item').on('click', async function(e) {
        var filterItem = $(e.currentTarget);
        var filterValue = filterItem.attr('data-filter_value');

        if (!productQuery.filter) {
            productQuery.filter = {};
        }

        if (!Array.isArray(productQuery.filter.lab)) {
            productQuery.filter.lab = [];
        }

        var isEnable = filterItem.hasClass('filter-enable');

        if (isEnable) {
            productQuery.filter.lab = productQuery.filter.lab.filter(v => v !== filterValue);
            filterItem.removeClass('filter-enable');
        } else {
            productQuery.filter.lab.push(filterValue);
            filterItem.addClass('filter-enable');
        }

        if (productQuery.filter.lab.length === 0) {
            delete productQuery.filter.lab;
        }

        page = 1;
        productQuery.page = page;

        console.log('lab filter:', productQuery.filter.lab);
        await loadProducts(productQuery, true);

        unscroll();
    });

    filterClarityContainer.find('.filter-list-item').on('click', async function(e) {
        var filterItem = $(e.currentTarget);
        var filterValue = filterItem.attr('data-filter_value');

        if (!productQuery.filter) {
            productQuery.filter = {};
        }

        if (!Array.isArray(productQuery.filter.clarity)) {
            productQuery.filter.clarity = [];
        }

        var isEnable = filterItem.hasClass('filter-enable');

        if (isEnable) {
            productQuery.filter.clarity = productQuery.filter.clarity.filter(v => v !== filterValue);
            filterItem.removeClass('filter-enable');
        } else {
            productQuery.filter.clarity.push(filterValue);
            filterItem.addClass('filter-enable');
        }

        if (productQuery.filter.clarity.length === 0) {
            delete productQuery.filter.clarity;
        }

        page = 1;
        productQuery.page = page;

        console.log('clarity filter:', productQuery.filter.clarity);
        await loadProducts(productQuery, true);

        unscroll();
    });

})();

let filtersButton = $('.filters-button');
let closeFiltersButton = $('.close-filter-block-button, #show-products-button');

filtersButton.on('click', function(e) {
    $('.filters').addClass('is-open');
});

closeFiltersButton.on('click', function(e) {
    $('.filters').removeClass('is-open');
});
